import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, DatePicker, Row, Col, Drawer } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { MEDIA_URL, LAPI_URL } from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'
import { FaAmazonPay } from "react-icons/fa";

import BranchInvoiveInboxView from '../../../components/Invoice/showBranchInvoiveInboxView';
import rightAuth from "../../../components/_utils/userRights";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let companySettings = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : [];
const { RangePicker } = DatePicker

@Form.create()
class UpdateInvoiceStatus extends Component {
  state = {
    visible: true,
    companyDetails: [],
    loading: false,
  }

  onClose = () => {
    this.setState({ visible: false }, () => {
      this.props.onClose();
    })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let { form, recordId } = this.props;
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData);
      values._id = recordId;
      this.setState({ loading: true });
      let response = await Request.updateBranchAPInvoiceStatus(values);
      this.setState({ loading: false });
      if (response.success) {
        notification.success({
          message: response.message
        });
      } else {
        notification.error({
          message: response.message
        });
      }
      this.onClose();
    })
  }

  async componentDidMount() {
    let response = await Request.getCompanyBankDetails();
    response.results = response.results.reduce((temp, vv) => {
      temp.push({ _id: vv._id, display: vv.companyName });
      return temp
    }, [])
    if (!response.error) {
      this.setState({ companyDetails: response.results });
    } else {
      notification.error({
        message: 'Error generating invoice'
      })
    }
  }


  render() {
    let { visible } = this.state;
    let { form: { getFieldDecorator } } = this.props;
    let inputTypes = {
      fields: [
        {
          label: 'Payment Status',
          key: 'paymentStatus',
          type: 'select',
          options: ["Paid"],
          required: true,
          onChange: v => {
            this.props.form.setFieldsValue({ paymentStatus: v })
          }
        },
        {
          label: 'Payment Receipt',
          key: 'receipt',
          type: 'file',
          required: true,
        },
        {
          label: 'Payment Via Bank Name',
          key: 'paymentBank',
          type: 'select',
          options: this.state.companyDetails,
          required: true,
          value: companySettings && companySettings.defaultBankDetailPayment ? companySettings.defaultBankDetailPayment : companySettings.defaultBankDetail ? companySettings.defaultBankDetail : null,
          onChange: v => {
            this.props.form.setFieldsValue({ paymentBank: v });
          }
        },
        {
          label: 'Payment Date',
          key: 'paymentDate',
          type: 'date',
          required: true,
          disabledDate: (current) => {
            return current && current > new Date(); // ❌ disable future
          }
        }
      ]
    }
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Update Invoice Status
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={800}
        visible={visible}>
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
            <div>
              <GetAllFormFields
                apiurl={LAPI_URL}
                inputSchema={inputTypes}
                getFieldDecorator={getFieldDecorator}
              />
            </div>
            <Row style={{ marginTop: '20px' }}>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.state.loading}>
                  Save
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>
      </Drawer>
    )
  }
}


class StudentsList extends Component {
  state = {
    visible: true
  }

  onClose = () => {
    this.setState({
      visible: false
    }, () => {
      this.props.onClose();
    })
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }



  render() {
    let { visible } = this.state;
    const currencySymbols = {
      USD: "$",      // US Dollar
      EUR: "€",      // Euro
      GBP: "£",      // British Pound
      INR: "₹",      // Indian Rupee
      AUD: "A$",     // Australian Dollar
      CAD: "C$",     // Canadian Dollar
      JPY: "¥",      // Japanese Yen
      CNY: "¥",      // Chinese Yuan
      NZD: "NZ$",    // New Zealand Dollar
      CHF: "CHF",    // Swiss Franc
      SGD: "S$",     // Singapore Dollar
      HKD: "HK$",    // Hong Kong Dollar
      SEK: "kr",     // Swedish Krona
      NOK: "kr",     // Norwegian Krone
      DKK: "kr",     // Danish Krone
      ZAR: "R",      // South African Rand
      AED: "د.إ",    // UAE Dirham
      SAR: "﷼",     // Saudi Riyal
      THB: "฿",      // Thai Baht
      MYR: "RM",     // Malaysian Ringgit
      IDR: "Rp",     // Indonesian Rupiah
      KRW: "₩",      // South Korean Won
      TRY: "₺",      // Turkish Lira
      RUB: "₽",      // Russian Ruble
      BRL: "R$",     // Brazilian Real
      MXN: "$",      // Mexican Peso
      PHP: "₱",      // Philippine Peso
      PLN: "zł",     // Polish Zloty
      HUF: "Ft",     // Hungarian Forint
      CZK: "Kč",     // Czech Koruna
    };
    let columns = [
      {
        title: 'Sr. No',
        key: 'serialNumber',
        render: (text, record, index) => (
          <div>{index + 1}</div>
        )
      },
      {
        title: 'VID',
        key: 'studentVisionId',
      },
      {
        title: 'Student Name',
        key: 'studentName',
      },
      {
        title: 'Passport Number',
        key: 'passportNumber',
      },
      {
        title: 'Student Id',
        key: 'instituteStudentId'
      },
      {
        title: 'University/College',
        key: 'universityInstitutionName',
      },
      {
        title: 'Course Name',
        key: 'courseName'
      },
      {
        title: 'Currency',
        key: 'currency',
      },
      {
        title: 'Comm Rate %',
        key: 'commissionFromCourse',
        render: (text, record) => (
          <div>{text.toFixed(2)}</div>
        )
      },
      {
        title: 'Tution Fee Paid',
        key: 'tutionFee',
        render: (value, record) => {
          const num = Number(value) || 0;
          return <div>{currencySymbols[record.currency]}{num.toFixed(2)}</div>;
        }
      },
      {
        title: 'Comm Recd',
        key: 'commissionTotal',
        render: (value, record) => {
          const num = Number(value) || 0;
          return <div>{currencySymbols[record.currency]}{num.toFixed(2)}</div>;
        }
      },
      {
        title: "INR Exchange Rate",
        key: "conversionRate",
        render: (value) => {
          const num = Number(value) || 0;
          return <div>{currencySymbols["INR"]}{num.toFixed(2)}</div>;
        }
      },
      {
        title: 'Bank Charges',
        key: 'bankCharges'
      },
      {
        title: "Comm Recd. INR",
        key: "grossPaymentReceived",
        render: (value) => {
          const num = Number(value) || 0;
          return <div>{currencySymbols["INR"]}{num.toFixed(2)}</div>;
        }
      },
      {
        title: 'Sharing Rate',
        key: 'sharingRate',
      },
      {
        title: "Associates",
        key: "associateAmount",
        render: (value, record) => {
          const num = Number(value) || 0;
          return <div>{currencySymbols["INR"]}{num.toFixed(2)}</div>;
        }
      }



    ];
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>
              Students List
            </React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={800}
        visible={visible}>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            dataSource={this.props.students}
            extraProps={{ scroll: { x: 1200 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </Drawer>
    )
  }
}

class AllFinanceBranchRequests extends Component {

  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    bonusAny: '',
    universityId: '',
    universities: [],
    courses: [],
    showInvoiveView: false,
    ShowBranchInvoiveInboxView: false,
    generatedInvoice: {},
    invoiceId: '',
    userBranch: '',
    showStudentDrawer: false,
    students: [],
    showInvoiceUpdateStatus: false,
    invoiceNumber: null,
    recordId: null,
    branchs: [],
    time: {
      from: null,
      to: null
    },
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      params.time = this.state.time;
      let data = await Request.getGeneratedBranchInvoices(params);
      this.setState({ total: data.total })
      resolve(data)
    })
  }

  componentWillMount() {
    this.setState({ userBranch: rightAuth.getUserAuth('userBranch') });
  }

  async componentDidMount() {
  }

  loadBranches = () => {
    let params = {
      sortField: 'branchName',
      sortOrder: 'ascend',
      results: 1000,
      count: 1000,
      status: true
    }
    Request.loadBranch({ ...params })
      .then(resp => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({ value: vv._id, text: vv.branchName })
          return temp
        }, [])
        this.setState({ branchs: resp.data });
      })
      .catch(err => {
        console.log(err)
      })
  }

  constructor(props) {
    super(props)
    this.table = React.createRef();
    this.loadBranches();
  }

  showInvoive = (record) => {
    let branchInvoice = record.invoiceUrl;
    let fullUrl = `${MEDIA_URL}${branchInvoice}`;
    window.open(fullUrl, "_blank");
  }

  updateInvoiceStatus = (recordId) => {
    this.setState({ showInvoiceUpdateStatus: true, recordId });
  }

  closeShowInvoiceDrawer = () => {
    this.setState({ showInvoiceUpdateStatus: false, recordId: null }, () => {
      this.table.current.reload();
    });
  }

  closeDocument = () => {
    this.setState({ showInvoiveView: false });
  }

  sendInvoice = (invoiceId) => {
    this.setState({ ShowBranchInvoiveInboxView: true, invoiceId: invoiceId });
  }

  closeInvoiceInbox = () => {
    this.setState({ ShowBranchInvoiveInboxView: false });
    let $this = this;
    setTimeout(function () {
      if ($this.table && $this.table.current) {
        $this.table.current.reload();
      }
    }, 500);
  }

  updateBranchInvoiceStatus = async (data) => {
    let x = await Request.completeBranchInvoice(data)
    if (!x.error) {
      notification.success({
        message: 'Invoice ' + data.invoiceStatus + ' successfully'
      });
      let $this = this;
      setTimeout(function () {
        if ($this.table && $this.table.current) {
          $this.table.current.reload();
        }
      }, 500);
    } else {
      notification.error({
        message: 'Error Saving',
        description: x.msg
      })
    }
  }

  numberFormat = (value) => {
    if (!value) {
      return value;
    }
    return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0],
          to: date[1]
        }
      }, () => {
        if (date[0] == undefined) {
          if (this.table && this.table.current) {
            this.table.current.reload();
          }
        }
      }
    )
  }


  showStudents = (students) => {
    this.setState({ showStudentDrawer: true, students });
  }

  closeStudentDrawer = () => {
    this.setState({ showStudentDrawer: false, students: [] });
  }

  onOk = value => {
    if (this.table && this.table.current) {
      this.table.current.reload();
    }
  }

  render() {
    const { dispatch } = this.props

    const { total, branchs, showInvoiveView, invoiceId, ShowBranchInvoiveInboxView, userBranch, showStudentDrawer, students, invoiceNumber, recordId, showInvoiceUpdateStatus } = this.state;

    const columns = [
      {
        title: "View Summary",
        key: "operation",
        render: (text, record) => (

          <div className={styles.btnWrapper}>
            <React.Fragment>
              <Tooltip title="View Invoice ">
                <Button
                  loading={false}
                  className={styles.btn}
                  onClick={() => { this.showInvoive(record) }}
                  shape="circle"
                  icon="eye"
                />
              </Tooltip>
              <Tooltip title="View Students ">
                <Button
                  loading={false}
                  className={styles.btn}
                  onClick={() => { this.showStudents(record.studentDetails) }}
                  shape="circle"
                  icon="team"
                />
              </Tooltip>
              {
                record.invoiceStatus === "Paid" ? null :
                  <Tooltip title="Update Status">
                    <Button
                      loading={false}
                      className={styles.btn}
                      onClick={() => { this.updateInvoiceStatus(record._id) }}
                      shape="circle"
                      icon="sync"
                    />
                  </Tooltip>
              }
            </React.Fragment>
          </div>
        ),
      },
      {
        title: 'Invoice Number',
        key: 'invoiceNumber',
        dataIndex: 'branchInvoiceNumber',
        searchTextName: 'Invoice Number',
        filterRegex: true
      },
      {
        title: 'Invoice Status',
        key: 'invoiceStatus',
        dataIndex: 'status',
        filters: [
          { value: 'Paid', text: 'Paid' },
          { value: 'Approved', text: 'Approved' },
        ]
      },
      {
        title: 'Branch/Ap Name',
        key: 'branch',
        dataIndex: 'branchDetails.branchName',
        filters: branchs
      },
      {
        title: 'Payment bank',
        key: 'paymentBank'
      },
      {
        title: 'Payment Receipt',
        key: 'paymentReceipt',
        render: (text, record) => {
          if (record.paymentReceipt && record.paymentReceipt.length > 0) {
            let fullUrl = `${MEDIA_URL}${record.paymentReceipt[0].url}`;
            return (
              <Button type='primary' icon='eye' onClick={() => window.open(fullUrl, '_blank')} />
            )

          } else {
            return (<div>NA</div>)
          }
        }
      },
      {
        title: 'Payment Date',
        key: 'paymentDate',
        searchTextName: `${dateFormat}`,
        render: (text, record) => (
          record.paymentDate ? moment(record.paymentDate).format(dateFormat) : "NA"
        )
      }
    ];

    return (
      <PageHeaderWrapper title={` All Branch Invoices: ${total} `}>
        {
          ShowBranchInvoiveInboxView ?
            <BranchInvoiveInboxView invoiceId={invoiceId} onClose={this.closeInvoiceInbox} />
            : null
        }
        {
          showStudentDrawer ?
            <StudentsList students={students} onClose={this.closeStudentDrawer} />

            : null
        }
        {
          showInvoiceUpdateStatus ?
            <UpdateInvoiceStatus recordId={recordId} onClose={this.closeShowInvoiceDrawer} />

            : null
        }
        <Card style={{ marginBottom: 10 }}>
          <div>
            {/* <Row>
              <Col span={8}>
                <label>Filter by Date</label>
                <RangePicker
                  showTime={{ format: 'HH:mm' }}
                  format="YYYY-MM-DD HH:mm"
                  placeholder={['Start Date', 'End Date']}
                  onChange={this.chooseRangerPicker}
                  onOk={this.onOk}
                />
              </Col>
            </Row> */}
          </div>
        </Card>
        <Card bordered={true}>
          <TableComp
            ref={this.table}
            columns={columns}
            apiRequest={this.apiRequest}
            extraProps={{ scroll: { x: 900 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ['10', '20', '50', '100', '1000']
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllFinanceBranchRequests
